import React from 'react';
import Navbar from './Navbar';
import'./HomePage.css';
import'./Responsive.css';
import LandingPge from './LandingPge';
import ProductsList from './ProductsList';
import Footer from './Footer';
import'../index.css';


const HomePage = () => {
  return (
   <div className='homePage'>
    <Navbar/>
    <LandingPge/>
    <ProductsList/>
    <Footer/>
   </div>
  )
}

export default HomePage